import { render, staticRenderFns } from "./WicktestModal.vue?vue&type=template&id=c7f7a616"
import script from "./WicktestModal.vue?vue&type=script&lang=js"
export * from "./WicktestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports